import type { ObbTakeoffData } from './obbTakeoff';

// Main staircase takeoff for the Kimbark Residence.
// Source: ~/Downloads/labels_aligned/stairs_03_bbox.txt (Stefan SI extraction).
// Coordinates: raw scene-3 Z-up. world_x=raw_x, world_y=raw_z, world_z=-raw_y.
// P0-P3 bottom (raw_z≈-1.38), P4-P7 top (raw_z≈+1.18). Pi↔P(i+4) verticals.
// Rectangle: P0-P2 & P1-P3 long sides (9'6"), P0-P1 & P2-P3 short sides (4'6").
// Height spans basement → ground floor: 8'5" ≈ 14 risers @ 7".

const P: [number, number, number][] = [
  [2.7573, -4.0853,  -1.3878],  // P0 bottom
  [3.2376, -2.7999,  -1.3728],  // P1 bottom
  [0.0360, -3.0686,  -1.3768],  // P2 bottom
  [0.5163, -1.7833,  -1.3618],  // P3 bottom
  [2.7566, -4.1150,   1.1748],  // P4 top
  [3.2368, -2.8296,   1.1899],  // P5 top
  [0.0353, -3.0983,   1.1858],  // P6 top
  [0.5155, -1.8130,   1.2009],  // P7 top
];

const mid = (a: [number,number,number], b: [number,number,number]): [number,number,number] =>
  [(a[0]+b[0])/2, (a[1]+b[1])/2, (a[2]+b[2])/2];

const off = (p: [number,number,number], d: [number,number,number]): [number,number,number] =>
  [p[0]+d[0], p[1]+d[1], p[2]+d[2]];

// Short axis (P0→P1): (0.350, 0.937, 0) × 0.4m
const SA: [number,number,number] = [0.14, 0.37, 0];
// Long axis (P0→P2): (-0.937, 0.350, 0) × 0.4m
const LA: [number,number,number] = [-0.37, 0.14, 0];

export const KIMBARK_STAIRCASE_TAKEOFF: ObbTakeoffData = {
  title:             'Staircase Takeoff',
  subtitle:          'Basement → Ground Floor',
  elementLabel:      'Main Staircase',
  elementDimensions: "9' 6\" × 4' 6\" × 8' 5\"",
  scanLabel:         'Scan 5',
  color:             '#60a5fa',  // blue-400

  obbPoints: P,

  dimensionAnchors: {
    a: { point: off(mid(P[0], P[2]), SA), label: "9' 6\"" },   // run (long)
    b: { point: off(mid(P[0], P[1]), LA), label: "4' 6\"" },   // width (short)
    c: { point: off(mid(P[0], P[4]), [0.3, 0, 0]),  label: "8' 5\"" }, // rise (height)
  },

  // From teleport panel while viewing the staircase (screenshot 2026-08-22)
  cameraPos:    [-2.702, 0.284, 4.386],
  cameraLookAt: [5.182, -0.359, 3.191],

  items: [
    { label: 'Stair risers',  modelQty: 14, unit: 'ea',     wastePercent: 0  },
    { label: 'Stair treads',  modelQty: 13, unit: 'ea',     wastePercent: 8  },
    { label: 'Stringers',     modelQty: 2,  unit: 'ea',     wastePercent: 0  },
    { label: 'Handrail',      modelQty: 10, unit: 'lin ft', wastePercent: 10 },
  ],
};
